import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEOSchema from "@/components/base/SEOSchema";
import { articles, features, reviews } from "@/mocks/articles";

const homeCategories = [
  {
    slug: "hot",
    name: "热门推荐",
    icon: "ri-fire-line",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20popular%20movie%20posters%20in%20cinematic%20collage%20style%2C%20warm%20golden%20lighting%2C%20film%20reel%20texture%2C%20entertainment%20vibe%2C%20clean%20dark%20background%2C%20artistic%20composition&width=800&height=450&seq=cat-hot-home-01&orientation=landscape",
  },
  {
    slug: "movie",
    name: "最新电影",
    icon: "ri-film-line",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20clapperboard%20with%20theater%20curtains%2C%20dramatic%20amber%20lighting%2C%20Hollywood%20vibe%2C%20warm%20gold%20tones%2C%20elegant%20dark%20composition%2C%20clean%20background&width=800&height=450&seq=cat-movie-home-01&orientation=landscape",
  },
  {
    slug: "tv",
    name: "电视剧",
    icon: "ri-tv-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20TV%20screen%20displaying%20drama%20series%2C%20cozy%20warm%20lighting%2C%20comfortable%20sofa%2C%20minimalist%20interior%2C%20home%20entertainment%2C%20clean%20atmosphere&width=800&height=450&seq=cat-tv-home-01&orientation=landscape",
  },
  {
    slug: "variety",
    name: "综艺节目",
    icon: "ri-live-line",
    image: "https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20spotlights%2C%20cheerful%20atmosphere%2C%20entertainment%20studio%20set%2C%20vibrant%20colors%2C%20dynamic%20lighting%2C%20clean%20composition&width=800&height=450&seq=cat-variety-home-01&orientation=landscape",
  },
  {
    slug: "anime",
    name: "动漫动画",
    icon: "ri-emotion-line",
    image: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20colorful%20vibrant%20characters%2C%20soft%20pastel%20palette%2C%20animation%20art%2C%20creative%20imaginative%20design%2C%20clean%20composition%2C%20gentle%20lighting&width=800&height=450&seq=cat-anime-home-01&orientation=landscape",
  },
  {
    slug: "doc",
    name: "纪录片",
    icon: "ri-slideshow-line",
    image: "https://readdy.ai/api/search-image?query=Nature%20documentary%20wildlife%20photography%2C%20earthy%20warm%20tones%2C%20National%20Geographic%20aesthetic%2C%20professional%20composition%2C%20natural%20lighting%2C%20clean%20background&width=800&height=450&seq=cat-doc-home-01&orientation=landscape",
  },
];

export default function Home() {
  const { t } = useTranslation();

  const hotArticles = articles.filter((a) => a.category === "hot").slice(0, 4);

  return (
    <>
      <SEOSchema
        type="WebSite"
        data={{
          name: "91影视看片下载",
          url: "https://www.91yingshi.com",
          description: "91影视看片下载官网，提供最新91影视看片APP下载，安卓手机影视APP免费安装，看片软件随时随地高清追剧。",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://www.91yingshi.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SEOSchema
        type="Organization"
        data={{
          name: "91影视看片下载",
          url: "https://www.91yingshi.com",
          description: "91影视看片下载官网，提供最新91影视看片APP下载",
          contactPoint: {
            "@type": "ContactPoint",
            email: "support@91yingshi.com",
            contactType: "customer service",
            availableLanguage: ["Chinese"],
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20theater%20setting%20with%20warm%20golden%20spotlights%20illuminating%20a%20smartphone%20floating%20in%20center%20displaying%20movie%20posters%2C%20elegant%20curtains%20on%20sides%2C%20dramatic%20lighting%2C%20luxurious%20atmosphere%2C%20film%20premiere%20vibe%2C%20rich%20dark%20amber%20and%20black%20tones%2C%20cinematic%20composition%2C%20high%20contrast&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
            alt="91影视看片APP - 手机影视APP"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              {t("hero_title")}
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              {t("hero_subtitle")}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#download"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-full text-base font-semibold whitespace-nowrap transition-all cursor-pointer shadow-lg shadow-primary-500/30"
              >
                <i className="ri-download-line text-lg"></i>
                {t("hero_cta")}
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white px-8 py-3.5 rounded-full text-base font-medium whitespace-nowrap transition-all cursor-pointer"
              >
                <i className="ri-arrow-down-line"></i>
                {t("hero_secondary")}
              </a>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="w-full bg-background-50 border-b border-background-200">
          <div className="max-w-5xl mx-auto px-4 md:px-6 py-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { value: "5000万+", label: "累计下载" },
              { value: "10万+", label: "影视资源" },
              { value: "4.8分", label: "用户评分" },
              { value: "每日更新", label: "内容更新" },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="w-full py-16 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                {t("features_title")}
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                {t("features_subtitle")}
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feat, i) => (
                <div
                  key={i}
                  className="bg-background-50 rounded-lg p-6 hover:bg-background-200/50 transition-all cursor-default group"
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                    <i className={`${feat.icon} text-xl text-primary-500`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                    {feat.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {feat.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                {t("category_title")}
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                {t("category_subtitle")}
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {homeCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group relative overflow-hidden rounded-lg cursor-pointer"
                >
                  <div className="relative h-48 md:h-56 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 flex items-center justify-center bg-primary-500/90 rounded-lg">
                          <i className={`${cat.icon} text-background-50 text-sm`}></i>
                        </div>
                        <h3 className="font-heading text-lg font-semibold text-white">{cat.name}</h3>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Recommendations */}
        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-12">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                  {t("recommend_title")}
                </h2>
                <p className="text-sm md:text-base text-foreground-500">
                  {t("recommend_subtitle")}
                </p>
              </div>
              <Link
                to="/category/hot"
                className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
              >
                {t("view_detail")}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {hotArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium">
                        热门
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views > 10000
                          ? `${(article.views / 10000).toFixed(1)}万`
                          : article.views}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <div className="mt-8 text-center sm:hidden">
              <Link
                to="/category/hot"
                className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
              >
                {t("view_detail")}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* User Reviews */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                用户真实评价
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                听听使用过91影视看片APP的用户怎么说
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {reviews.map((review, i) => (
                <div key={i} className="bg-background-100 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: review.rating }).map((_, j) => (
                          <i key={j} className="ri-star-fill text-xs text-accent-500"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  <div className="mt-3 text-xs text-foreground-400">{review.date}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Download CTA */}
        <section id="download" className="w-full py-16 md:py-20 bg-foreground-900 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20warm%20amber%20and%20gold%20gradients%2C%20cinematic%20texture%2C%20dark%20background%2C%20luxurious%20atmosphere%2C%20subtle%20elegant%20design%2C%20clean%20minimal%20composition&width=1600&height=600&seq=cta-bg-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
              {t("download_title")}
            </h2>
            <p className="text-sm md:text-base text-background-50/70 mb-8">
              {t("download_subtitle")}
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-600 text-background-50 px-10 py-4 rounded-full text-lg font-semibold whitespace-nowrap transition-all cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <i className="ri-android-line text-xl"></i>
              {t("download_btn")}
            </a>
            <p className="mt-4 text-xs text-background-50/40">
              {t("download_tip")}
            </p>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                关于91影视看片APP的常见疑问解答
              </p>
            </div>
            <SEOSchema
              type="FAQPage"
              data={{
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "91影视看片APP是否免费？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "是的，91影视看片APP完全免费，无需会员订阅即可观看海量影视资源。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "91影视看片APP支持哪些设备？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "91影视看片APP目前支持Android 5.0及以上版本的手机和平板设备，同时支持投屏到智能电视观看。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "如何下载91影视看片APP？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "您可以在91影视看片下载官网直接下载最新版APK安装包，按照安装教程完成安装即可使用。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "91影视看片APP是否支持离线观看？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "支持。91影视看片APP提供一键离线缓存功能，您可以将喜欢的影片下载到本地，无网络也能随时随地观看。",
                    },
                  },
                ],
              }}
            />
            <div className="space-y-3">
              {[
                {
                  q: "91影视看片APP是否免费？",
                  a: "是的，91影视看片APP完全免费，无需会员订阅即可观看海量影视资源。",
                },
                {
                  q: "91影视看片APP支持哪些设备？",
                  a: "91影视看片APP目前支持Android 5.0及以上版本的手机和平板设备，同时支持投屏到智能电视观看。",
                },
                {
                  q: "如何下载91影视看片APP？",
                  a: "您可以在91影视看片下载官网直接下载最新版APK安装包，按照安装教程完成安装即可使用。",
                },
                {
                  q: "91影视看片APP是否支持离线观看？",
                  a: "支持。91影视看片APP提供一键离线缓存功能，您可以将喜欢的影片下载到本地，无网络也能随时随地观看。",
                },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-100 rounded-lg">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer">
                    <span className="text-sm md:text-base font-medium text-foreground-900">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}